export enum PATH_STRINGS {
    base = '/',
    noRoute = '/*',
    logIn = '/log-in',
    redirectOnSuccessfulLogin = '/log-in/success',
    travelDatabase = '/travel-database',
    selectTravelComponents = '/travel-database/select-travel-component',
    help = '/travel-database/help',
    termsAndConditionsAdmin = '/terms-and-conditions',
    termsAndConditionsUser = '/please-contact-your-company-admin',
    register = '/register',
    newJourney = '/travel-database/new-journey',
    journey = '/travel-database/journey',
    addActivityToJourney = "/travel-database/add-new/journey",
    addActivityToTravelComponents = "/travel-database/add-new/travel-component",
    editActivity = "/travel-database/edit",
    travelComponentsOverview = '/travel-database/travel-components',
    settings = "/travel-database/settings"
}

export enum PATH_SCREEN_STRING {
    tc = 'tc',
    journey = 'journey'
}